import axios from 'axios'
import store from '@/store'
import LocalStore from '@/utils/localStore'

// 创建axios实例
const axiosInstance = axios.create({
  baseURL: process.env.API_ROOT
})

// request拦截器
axiosInstance.interceptors.request.use(config => {
  // Do something before request is sent
  const jwtToken = LocalStore.getToken()
  if (jwtToken) {
    config.headers.Authorization = 'Bearer ' + jwtToken
  }
  if (config.url.indexOf('shops/current') >= 0) {
    config.url = config.url.replace('shops/current', 'shops/' + store.state.shopInfo._id)
  }
  if (config.url.indexOf('users/own') >= 0) {
    config.url = config.url.replace('users/own', 'users/' + store.state.userInfo._id)
  }
  return config
}, error => {
  // Do something with request error
    return Promise.reject(error)
})

// respone拦截器
axiosInstance.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return response
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        return Promise.reject(error)
    }
)

const Api = {
  instance: axiosInstance,
  request: axiosInstance.request,
  get: axiosInstance.get,
  delete: axiosInstance.delete,
  head: axiosInstance.head,
  post: axiosInstance.post,
  put: axiosInstance.put,
  patch: axiosInstance.patch
}

// 获取当前店铺信息
Api.getShopInfoByCName = cname => {
    return Api.get('/shop/' + cname)
}
// 获取当前店铺信息
Api.getShopInfo = () => {
    return Api.get('/shops/current')
}

// 获取当前登录用户信息
Api.getUserInfo = () => {
    return Api.get('/auth')
}

// 获取收货地址
Api.getAddressList = () => {
    return Api.get('/users/own/addresses')
}

// 获取默认收货地址
Api.getDefaultAddress = () => {
    return Api.get('/users/own/addresses/default')
}

// 增加收货地址
Api.addAddress = data => {
    return Api.post('/users/own/addresses', data)
}

// 更新收货地址
Api.updateAddress = data => {
    return Api.patch('/users/own/addresses/' + data._id, data)
}

// 收货地址
Api.delAddress = addressId => {
    return Api.delete('/users/own/addresses/' + addressId)
}

// 获取商品列表
Api.getProductList = params => {
    params.salesChannel = 'lifegeo'
    return Api.get('/shops/current/products/sales', { params: params })
}

// 获取活动商品列表
Api.getActivity = addressId => {
    return Api.get('/shops/current/activities/' + addressId)
}

// 获取商品详情
Api.getProductDetail = (productId, channel) => {
    return Api.get('/shops/current/products/' + productId + '?channel=' + channel)
}

// 获取商品分类
Api.getCategoriesList = params => {
    return Api.get('/shops/current/categories', { params: params })
}
// 获取商品分类
Api.getBrandsList = params => {
    return Api.get('/shops/current/brands', { params: params })
}

// 获取购物车信息
Api.getCartList = () => {
    return Api.get('/shops/current/member/cart')
}

// 获取购物车数量
Api.getCartCount = () => {
    Api.get('/shops/current/member/cart')
        .then(res => {
            if (res && res.data && res.data.length) {
                store.commit('updateCartCount', res.data.length)
            }
        })
}

// 加入购物车
Api.addProductToCart = data => {
    return Api.post('/shops/current/member/cart', data)
}

// 清空购物车
Api.deleteCart = () => {
    return Api.delete('/shops/current/member/cart')
}

// 购物车增减数量
Api.updatedCartQuantity = (productId, data) => {
    return Api.patch('/shops/current/member/cart/' + productId, data)
}

// 购物车删除指定商品
Api.deleteProductCart = productId => {
    return Api.delete('/shops/current/member/cart/' + productId)
}
// 购物车删除指定商品
Api.batchDeleteProductCart = data => {
    return Api.post('/shops/current/member/cart/remove', data)
}

// 创建订单
Api.createOrder = data => {
    return Api.post('/shops/current/member/orders', data)
}

Api.wxConfig = params => {
    return Api.get('/wechat/config', { params: params })
}

Api.wxPay = orderId => {
    return Api.post('/shops/current/member/orders/' + orderId + '/wxpay')
}
Api.wxh5pay = orderId => {
    return Api.post('/shops/current/member/orders/' + orderId + '/wxh5pay')
}

Api.alipay = orderId => {
    return Api.get('/alipay/pay/' + orderId)
}

// 确认收货
Api.orderReceived = orderId => {
    return Api.post('/shops/current/member/orders/' + orderId + '/received')
}

// 取消订单
Api.orderCancel = orderId => {
    return Api.post('/shops/current/member/orders/' + orderId + '/cancel')
}
// 申请退款
Api.refundOrder = orderId => {
    return Api.post('/shops/current/member/orders/' + orderId + '/refund')
}
// 物流信息
Api.getOrder = orderId => {
    return Api.get('/shops/current/member/orders/' + orderId)
}
// 物流信息
Api.orderExpressInfo = orderId => {
    return Api.get('/shops/current/member/orders/' + orderId + '/express-info')
}

// 创建订单
Api.getOrderList = params => {
    return Api.get('/shops/current/member/orders', { params: params })
}

// 创建订单
Api.getOrderShipment = params => {
    return Api.get('/shops/current/member/orders/shipment', { params: params })
}

// 获取个人信息
Api.getOwn = () => {
    return Api.get('/auth')
}

// 获取收藏列表
Api.getFavoritesList = () => {
    return Api.get('/shops/current/member/favorites')
}

// 添加收藏
Api.addFavorite = data => {
    return Api.post('/shops/current/member/favorites', data)
}

// 获取此商品是否已收藏
Api.getIsFavorite = productId => {
    return Api.get('/shops/current/member/favorites/' + productId)
}

// 从收藏中删除
Api.deleteFavorite = productId => {
    return Api.delete('/shops/current/member/favorites/' + productId)
}

Api.getCoupon = (params) => {
  return Api.get('/shops/current/coupons/detail/' + params.id)
}
Api.getCouponType = (params) => {
  return Api.get('/shops/current/coupons/type/' + params.id)
}
Api.getCouponTypeCollectedNumber = (params) => {
  return Api.get('/shops/current/coupons/type/' + params.id + '/collected')
}
Api.collectCoupon = (params) => {
  return Api.post('/shops/current/coupons/type/collect/' + params.id)
}

// 获取优惠券列表
Api.getCouponsList = params => {
    return Api.get('/shops/current/member/coupons', { params: params })
}

// 添加优惠券
Api.addCoupon = data => {
    return Api.post('/shops/current/member/coupons', data)
}

// 购物车删除指定商品
Api.getHomePage = () => {
    return Api.get('/shops/current/homepage')
}

// 获取订单数量
Api.getOrdersCounts = () => {
    return Api.get('/shops/current/member/orders/counts')
}

// 获取配送方式列表
Api.shippingMethodsList = params => {
    return Api.get('/shops/current/shipping-methods', { params: params })
}
// 发送短信验证码
Api.sendSMSCode = data => {
    return Api.post('/shops/current/member/sendSMSCode', data)
}
// 绑定手机号码
Api.bindMobileNumber = data => {
    return Api.post('/shops/current/member/bindMobileNumber', data)
}

// 发送短信验证码
Api.sendLoginSMSCode = data => {
    return Api.post('/auth/sms', data)
}
Api.smsLogin = data => {
    return Api.post('/auth/smsLogin', data)
}
// 获取用户二维码
Api.getQrcode = () => {
    return Api.get('/shops/current/member/qrcode')
}

export default Api



// WEBPACK FOOTER //
// ./src/utils/api.js